<template>
  <v-card>
    <v-toolbar card dense color="transparent">
      <v-toolbar-title><h5>CAE CIRS Description</h5></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>more_vert</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <template>
        <v-data-table :headers="headers" :items="projects" hide-actions class="elevation-0">
          <template slot="items" slot-scope="props">
            <td>{{ props.item['CaeCirs.code'] }}</td>
            <td class="text-xs-left">{{ props.item['CaeCirs.description'] }}</td>
            <td class="text-xs-left">{{ props.item['Facts.count']}}</td>
            <!-- caso seja util
            <td class="text-xs-left">
              <v-progress-linear :value="props.item['Facts.count']" height="5" :color="props.item.color"></v-progress-linear>
            </td>-->
          </template>
        </v-data-table>
      </template>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</template>

<script>
// import { Projects } from "@/api/project"
import { getCaeCirsDescriptions } from "../../../databaseRequests";

var list = getCaeCirsDescriptions();

export default {
  name: "PlainTableCC",
  data() {
    return {
      headers: [
        {
          text: "Code",
          align: "left",
          value: "name"
        },
        { text: "Description", value: "deadline" },
        { text: "Presence", value: "progress" }
      ]
    }
  },
  computed: {
    projects() {
      return list
    }
  }
}
</script>
